import React, { useEffect, useMemo, useState } from 'react';
import { useMutation } from 'react-apollo';
import { addAction, clearAction, removeAction, updateAction } from './action-creators';
import { flattenList } from './list-transforms';
import { ProductListContext } from './ProductListContext';
import { trackAddToWishListEvent } from '../../analytics/tracking';
import { useTracker } from '../../analytics/Analytics';
export function useProductList(listId = null) {
    const { 
    // XXX
    //state: { list = {} },
    state, dispatch, queries, usingLocalList } = React.useContext(ProductListContext);
    const list = state.lists.get(listId);
    const [hydrated, setHydrated] = useState(!usingLocalList);
    const updateAPI = !usingLocalList;
    const removeMutation = useMutation(queries.remove);
    const addMutation = useMutation(queries.add);
    const track = useTracker();
    function toggle(articleNumber, { variantArticleNumber, quantity, description, productName }) {
        if (inList(articleNumber, { variantArticleNumber })) {
            remove(articleNumber, { variantArticleNumber });
        }
        else {
            add(articleNumber, {
                variantArticleNumber,
                quantity,
                description,
                productName
            });
        }
    }
    function remove(articleNumber, { variantArticleNumber }) {
        dispatch(removeAction({
            listId,
            articleNumber,
            variantArticleNumber,
            removeMutation,
            updateAPI
        }));
    }
    function add(articleNumber, { variantArticleNumber, quantity = 1, description, productName }) {
        track(trackAddToWishListEvent({
            articleNumber: variantArticleNumber || articleNumber,
            productName
        }));
        dispatch(addAction({
            listId,
            updateAPI,
            articleNumber,
            variantArticleNumber,
            options: { quantity, description },
            addMutation
        }));
    }
    function update(articleNumber, { variantArticleNumber, quantity, description, variantToReplace }) {
        dispatch(updateAction({
            listId,
            updateAPI,
            articleNumber,
            variantArticleNumber,
            variantToReplace,
            options: { quantity, description },
            removeMutation,
            addMutation
        }));
    }
    function clear() {
        dispatch(clearAction({ listId, removeMutation, updateAPI }));
    }
    function inList(articleNumber, { variantArticleNumber }) {
        var _a;
        if (!hydrated)
            return false;
        if (list && articleNumber in list.items) {
            if (!variantArticleNumber)
                return true;
            const variantInList = !!((_a = list.items[articleNumber].variants) === null || _a === void 0 ? void 0 : _a[variantArticleNumber]);
            return variantInList;
        }
        else {
            return false;
        }
    }
    //  When using localStorage, we only want to display the list values after
    //  hydration, to avoid the initial server and client render being different
    useEffect(() => {
        setHydrated(true);
    }, []);
    const count = useMemo(() => {
        return hydrated ? flattenList(list).length : 0;
    }, [hydrated, list]);
    return { toggle, add, remove, update, clear, inList, list, count };
}
//# sourceMappingURL=useProductList.js.map